import * as CryptoJS from "crypto-js";

export const encryptWithAES = (text) => {
  const passphrase = process.env.REACT_APP_CIPHER_PASS;
  return CryptoJS.AES.encrypt(text, passphrase).toString();
};
